<template>
  <WsUpdate
    :modelName="modelName"
    :id="$route.params.id"
    :label="label"
    :fields="_fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    titleKey="name"
  >
  </WsUpdate>
</template>

<script>
import model from "@/models/factory";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "工廠資訊",
              fields: [
                "locales",
                "factory",
                "register_number",
                "uniform_number",
                "remark",
                "attaches",
                "max_member_count",
                "subscriptions",
                "address",
                "administrator_name",
                "administrator_email",
                "administrator_password",
              ],
            },
          ],
        },
        {
          type: "infoCard",
          floors: [
            {
              title: "工廠季度",
              fields: ["season_start_month"],
            },
          ],
        },
      ],
      secondary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "設定",
              fields: [
                "area",
                "industry_categories",
                "start_date",
                "due_date",
                "app",
                "type",
                "subscription_api_modules",
                "is_image_viewable",
                'map_url',
                'is_alliance_home_page',
              ],
            },
          ],
        },
        {
          type: "infoCard",
          floors: [
            {
              title: "訂閱設定",
              fields: [
                "subscription_areas",
                "subscription_industry_categories",
                "system_classes",
                "system_subclasses",
                "subscription_topic",
                "subscription_locales",
                "subscription_alliances",
              ],
            },
          ],
        },
        {
          type: "infoCard",
          floors: [
            {
              title: "開通設定",
              remark: "停用的內容將不會顯示於使用者前台介面",
              fields: ["status"],
            },
          ],
        },
        {
          type: "infoCard",
          floors: [
            {
              title: "標籤設定",
              remark: "標籤僅供後台檢索，不影響前台使用",
              fields: ["tags"],
            },
          ],
        },
      ],
    },
  }),
  computed: {
    _fields() {
      let _fields = this.fields;
      delete _fields.administrator_password.getRules;
      _fields.administrator_password.placeholder = "若無變更密碼則不需填寫此欄";
      return _fields;
    },
  },
};
</script>